import React from 'react'
import heartIcon from "../../assets/images/icons/heart.png"

const Footer = () => {
  return (
    <div id="footer">Made with<img src={heartIcon} alt="heart" />by Karena Li. Copyright 2024 - All rights reserved.</div>
  )
}

export default Footer
